<Div>
<div class="section-training">
  <button gbc-button (click)="createTrainingData()">Create Training Data</button>
  <button gbc-button (click)="deleteTrainingData()">Delete Training Data</button>
  Training Data State: {{ error }}
</div>

<div>
  <button (click)="createNewUser()">Create new user</button>
  <!-- <button (click)="edit()">{{ uiState === 'edit' ? 'Cancel' : 'Edit' }}</button> -->
  Filter:
  <gbc-input-field
    class="overview-header-row-right-container-filter"
    [placeholderTranslationString]="'create-edit-user.name'"
    [(ngModel)]="currentfilter"
    >
  </gbc-input-field>
  <!-- ListUsers -->
  @if (uiState === 'list' || uiState === 'edit') {
    <div class="list">
      <table class="table table-striped">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col" sortable="Name">Name</th>
            <th scope="col" sortable="CompanyName">Company</th>
            <th scope="col" sortable="Phone">Phone</th>
            <th scope="col" sortable="Email">Email</th>
            @if (uiState === 'edit') {
              <th scope="col">Modify</th>
            }
            @if (uiState === 'edit') {
              <th scope="col">X</th>
            }
          </tr>
        </thead>
        @if (users$ | async | filterCompanyOnName: currentfilter; as users) {
          <tbody>
            <!-- | async -->
            @for (user of users; track user) {
              <tr>
                <th scope="row">{{ user.id }}</th>
                <td>{{ user.name }}</td>
                <td>{{ user.company?.name }}</td>
                <td>{{ user.phone }}</td>
                <td>{{ user.email }}</td>
                <td>
                  @if (uiState === 'edit') {
                    <button class="deleteButton" (click)="modifyUser(user)">Modify</button>
                  }
                </td>
                <td>
                  @if (uiState === 'edit') {
                    <button class="deleteButton" (click)="deleteUser(user)">X</button>
                  }
                </td>
              </tr>
            }
          </tbody>
        }
      </table>
    </div>
  }

  <!-- CreateUser -->
  @if (uiState === 'create' || uiState === 'modify') {
    <div class="formDiv">
      <form class="newForm" [formGroup]="form" (ngSubmit)="onSubmit()">
        @if (selectedUserId) {
          <div class="activeRow ml-1">
            ID:
            <label class="formElement">{{ selectedUserId }}</label>
          </div>
        }
        <input class="formElement" placeholder="Name" type="text" formControlName="Name" />
        <input class="formElement" placeholder="Phone Number" type="text" formControlName="Phone" />
        <input class="formElement" placeholder="Email" type="text" formControlName="Email" />
        <!-- ServiceGroups -->
        <ng-select
          class="select"
          placeholder="Select ServiceGroup(s)"
          [items]="serviceGroups$ | async | sortByName"
          bindLabel="name"
          [searchable]="true"
          formControlName="ServiceGroups"
          [multiple]="true"
          >
        </ng-select>
        <!-- Company -->
        @if (form.controls.ServiceGroups.value) {
          <div>
            <ng-select
              class="select"
              [items]="companies$ | async"
              bindLabel="name"
              bindValue="id"
              [multiple]="false"
              placeholder="Select Company"
              formControlName="CompanyId"
              >
            </ng-select>
          </div>
        }
        <button type="submit" [disabled]="!form.valid">Submit</button>
        <button type="reset" (click)="cancelNewUser()">Cancel</button>
      </form>
    </div>
  }
</div>
</Div>
